import { post, del, get, patch } from 'aws-amplify/api';
import { processResponse } from './api_util';
import useSWR from 'swr'
import { handleApiResponse } from './api_util';


async function getBankAccounts() {

    const payload = {
        apiName: 'LivisiblyBankAccountApi',
        path: `account`

    }

    const restOperation = get(payload);


    const response = await restOperation.response;

    return processResponse(response)
}

export function useGetBankAccounts(shouldFetch = true) {
    const result = useSWR(
        shouldFetch ? 'BANKACCOUNTS' : null,
        (path) => getBankAccounts()
    );
    return result;
}



async function getBankStatementsForAccount(accountID, limit=null) {

    const payload = {
        apiName: 'LivisiblyBankAccountApi',
        path: `account/${accountID}/statement${limit ? `?limit=${limit}` : ''}`
    }

    const restOperation = get(payload);


    const response = await restOperation.response;

    return processResponse(response)
}

export function useGetBankStatementsForAccount(accountID, limit=null, shouldFetch = true) {
    const result = useSWR(
        shouldFetch ? ['BANKSTATEMENTS', accountID, limit] : null,
        (path) => getBankStatementsForAccount(accountID, limit)
    );
    return result;
}

async function getAccountSummaries() {

    const payload = {
        apiName: 'LivisiblyBankAccountApi',
        path: `account/summary`
    }

    const restOperation = get(payload);

    const response = await restOperation.response;

    return processResponse(response)
}

export function useGetAccountSummaries(shouldFetch = true) {
    const result = useSWR(
        shouldFetch ? 'ACCOUNT_SUMMARIES' : null,
        () => getAccountSummaries(),
        { revalidateOnFocus: false }
    );
    return result;
}


async function getBankTransactionsForStatement(accountID, periodID, limit=null) {

    const payload = {
        apiName: 'LivisiblyBankAccountApi',
        path: `account/${accountID}/statement/${periodID}/transaction${limit ? `?limit=${limit}` : ''}`
    }

    const restOperation = get(payload);


    const response = await restOperation.response;

    return processResponse(response)
}

export function useGetBankTransactionsForStatement(accountID, periodID, limit=null, shouldFetch = true) {
    const result = useSWR(
        shouldFetch ? ['BANKTRANSACTIONS', accountID, periodID, limit] : null,
        (path) => getBankTransactionsForStatement(accountID, periodID, limit)
    );
    return result;
}


